import { render, staticRenderFns } from "./AlertHandler.vue?vue&type=template&id=0e8ce656&scoped=true"
import script from "./AlertHandler.vue?vue&type=script&lang=ts"
export * from "./AlertHandler.vue?vue&type=script&lang=ts"
import style0 from "./AlertHandler.vue?vue&type=style&index=0&id=0e8ce656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8ce656",
  null
  
)

export default component.exports